import { readRedirectUri, SignInPage } from "@acquire-intelligence/ai-labs-auth-component";
import { useLocation } from "react-router-dom";
import { authClient } from "../lib/api";

/**
 * Self-service password reset, linked from the reset email itself. The same
 * SignInPage, opened on its reset view; redirect_uri rides along so somebody a
 * project sent to sign in still lands on that project afterwards.
 */
export function ResetPasswordPage() {
  const location = useLocation();
  return (
    <SignInPage
      client={authClient}
      initialView="reset"
      redirectUri={readRedirectUri(location.search)}
    />
  );
}
